import Cookies from 'js-cookie';

export default class MediaController {
	constructor(autoinit = true) {
		if (autoinit) {
			window.addEventListener('CookiebotOnLoad', () => {
				this.init();
			})
		}
	}
 
	init() {
		this.initMediaItems();	
		this.addEventListeners();

		window.slimmage.cr();
	}

	initMediaItems() {
		document.querySelectorAll('noscript').forEach(media => {
			switch (media.dataset.mediatype) {
				case 'youtube':
					this.youtube(media);
					break;
				case 'vimeo':
					this.vimeo(media);
					break;
			}
		}
	);}
	

	addEventListeners() {
		if(document.querySelector('button.acceptCookies')){
			document.querySelectorAll('button.acceptCookies').forEach(button => {
				button.closest("[data-gallery]").removeAttribute('data-gallery-type');
				button.closest("[data-gallery]").removeAttribute('data-gallery');
				button.addEventListener('click', (click) => {
					click.preventDefault();
					click.stopPropagation();
					if(window.CookieConsent?.consent?.marketing){
						window.CookieConsent.consent.marketing = true;
					} else if (window.Cookiebot){
						window.Cookiebot.show();
					} else {
						window.location.href = '/privacy-en-cookies/';
					}
				});
			});
		}
	}

	embedIframe(url, type, id, imgtag) {
		// External sites use tracking, so the tracking cookie needs to be enabled
		imgtag = imgtag.replace('&lt;', '<').replace('&gt;', '>')
		if (window.CookieConsent?.consent?.marketing) {
			return `
			<div class="videoContainer">
				<div class="video">
					<iframe class="${type}" id="${id}" src="${url}" width="100%" height="100%" frameborder="0" title="Klik om de video te bekijken" webkitAllowFullScreen mozallowfullscreen allowFullScreen allow="autoplay"></iframe>
				</div>
			</div>`;
		} else {
			return `
			<div class="videoContainer notAccepted">
				<div class="content">
					<p class="title">Deze video heeft cookies nodig</p>
					<p>U heeft aangegeven liever geen cookies van YouTube of Vimeo te krijgen. Deze cookies zijn nodig om deze video te tonen.</p>
					<p>Klik op de knop hieronder om akkoord te gaan met de cookies</p>
					<button class="button acceptCookies">Ik ga akkoord</button> 
				</div>
			</div>
			`;
		}
	}

	youtube(media) {
		const url = `https://www.youtube-nocookie.com/embed/${media.dataset.youtube}?wmode=opaque&rel=0&enablejsapi=1&origin=${window.location.protocol}//${window.location.hostname}`;
		const embed = this.embedIframe(url, "youtube", media.dataset.youtube, media.innerHTML);

		let tempDiv = document.createElement('div');
		tempDiv.innerHTML = embed;

		media.before(tempDiv.firstElementChild);
		media.remove();
	}

	vimeo(media) {
		const url = `https://player.vimeo.com/video/${media.dataset.vimeo}?title=0&byline=0&portrait=0&api=1`;
		const embed = this.embedIframe(url, "vimeo", media.dataset.vimeo, media.innerHTML);

		let tempDiv = document.createElement('div');
		tempDiv.innerHTML = embed;

		media.before(tempDiv.firstElementChild);
		media.remove();
	}

}